import type { DisplayedPriceVariant } from '@wix/restaurants-populated-item-client/types';

export const getVariantById = ({
  priceVariantsInItem,
  variantId,
}: {
  priceVariantsInItem: DisplayedPriceVariant[];
  variantId: string;
}) => priceVariantsInItem.find((priceVariant) => priceVariant.id === variantId);

export const getVariantWithMinimalPrice = (
  variantListItems: DisplayedPriceVariant[],
): DisplayedPriceVariant | undefined =>
  variantListItems.reduce<DisplayedPriceVariant | undefined>(
    (prev, curr) =>
      !prev || Number(curr.priceInfo?.price) < Number(prev.priceInfo?.price)
        ? curr
        : prev,
    undefined,
  );
